import React, { useContext } from 'react';
import { translate } from '@utils/i18n';
import { Controller, useFormContext } from 'react-hook-form';
import { TimeZoneContext } from '@contexts/timezone-context';
import { transformDayJstoDate } from '@utils/dateUtils';
import { dateClient } from '@utils/date-client';
import { Button } from '@ui';
import AssigneeMultiSelect from '@components/Multiselects/AssigneeMultiselect';
import { TenantContext } from '@contexts/tenant-context';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import DateInput from '@components/DateInput/DateInput';
import TimeInput from '@components/TimeInput/TimeInput';
import { NewGenericEventModalContext } from '../../NewGenericEventModalContext';
import Duration from './duration';
function DetailsSection() {
    var _a;
    const namespace = 'features.modals.new_generic_event_modal.details_section';
    const { tenant } = useContext(TenantContext);
    const { timeZoneList } = useContext(NewGenericEventModalContext);
    const { timeZonesMapping } = useContext(TimeZoneContext);
    const { control, watch, setValue } = useFormContext();
    const formValues = watch();
    const handleDateChange = (field, e) => {
        const newDate = e.value;
        if (!newDate)
            return;
        const date = dateClient(newDate)
            .tz(timeZonesMapping[formValues.timeZone])
            .year(newDate.getFullYear())
            .month(newDate.getMonth())
            .date(newDate.getDate())
            .hour(field.value.hour())
            .minute(field.value.minute())
            .second(field.value.second())
            .millisecond(field.value.millisecond());
        field.onChange(date);
    };
    const handleTimeChange = (field, e) => {
        const newTime = e.value;
        if (!newTime)
            return;
        const date = dateClient(field.value)
            .tz(timeZonesMapping[formValues.timeZone])
            .year(field.value.year())
            .month(field.value.month())
            .date(field.value.date())
            .hour(newTime.getHours())
            .minute(newTime.getMinutes())
            .second(newTime.getSeconds())
            .millisecond(newTime.getMilliseconds());
        field.onChange(date);
    };
    return (React.createElement("div", { className: "detailsSection" },
        React.createElement(Controller, { name: "technicianIds", control: control, rules: { required: true }, render: ({ field }) => (React.createElement("div", null,
                React.createElement("span", { className: "qmb-label--required" }, translate('assign_to', { namespace })),
                React.createElement(AssigneeMultiSelect
                // eslint-disable-next-line react/style-prop-object
                , { 
                    // eslint-disable-next-line react/style-prop-object
                    style: "modal", skipUnassigned: true, onlyTechnicians: true, hasSelectAll: true, teamIds: null, selectedTechnicianIds: field.value, selectedSubcontractorIds: [], onTechChange: field.onChange, onSubChange: () => { } }))) }),
        ((_a = tenant === null || tenant === void 0 ? void 0 : tenant.flags) === null || _a === void 0 ? void 0 : _a.hasMultiTimezone) && (React.createElement(Controller, { name: "timeZone", control: control, render: ({ field }) => {
                const selectedValue = timeZoneList.find((option) => option.value === field.value);
                return (React.createElement("div", { className: "qmb-select--x-full" },
                    React.createElement(DropDownList, { name: field.name, id: field.name, textField: "label", dataItemKey: "value", data: timeZoneList, value: selectedValue, onChange: (e) => field.onChange(e.value.value), disabled: false, size: "large" }),
                    React.createElement("label", { className: "qmb-label" }, translate('time_zone', { namespace }))));
            } })),
        React.createElement("div", { className: "equalChildren" },
            React.createElement(Controller, { name: "start", control: control, render: ({ field }) => (React.createElement(DateInput, { id: field.name, value: transformDayJstoDate(field.value), name: field.name, onChange: (e) => handleDateChange(field, e), label: translate('start_date', { namespace }), required: true })) }),
            formValues.allDay ? (React.createElement(Controller, { name: "end", control: control, render: ({ field }) => (React.createElement(DateInput, { id: field.name, value: transformDayJstoDate(field.value), name: field.name, onChange: (e) => handleDateChange(field, e), label: translate('end_date', { namespace }), required: true })) })) : (React.createElement("div", { style: { width: '100%' } },
                React.createElement(Button, { variant: "default", onClick: () => setValue('allDay', true) }, translate('add_end_date', { namespace }))))),
        React.createElement("div", { className: "equalChildren" },
            React.createElement(Controller, { name: "start", control: control, render: ({ field }) => (React.createElement(TimeInput, { id: field.name, value: transformDayJstoDate(formValues.allDay ? field.value.startOf('day') : field.value), name: field.name, onChange: (e) => handleTimeChange(field, e), label: translate('start_time', { namespace }), disabled: formValues.allDay, required: !formValues.allDay })) }),
            React.createElement(Controller, { name: "allDay", control: control, render: ({ field }) => (React.createElement("label", { className: "qmb-checkbox" },
                    React.createElement("input", { id: field.name, type: "checkbox", checked: field.value, onChange: field.onChange }),
                    translate('all_day', { namespace }))) })),
        !formValues.allDay && React.createElement(Duration, null)));
}
export default DetailsSection;
